import type { PageRow, TimelineWidget as TimelineWidgetSpec } from '@developerz/domain';
import { For, type JSX, Show } from 'solid-js';
import { t } from '../../i18n';
import { formatCell } from '../../lib/widget-format';

// `timeline` presenter (arc 101 slice 09) — a time-ordered event feed (the
// run-event stream) on the §3.13 timeline rail. Rows arrive server-ordered; each
// shows a `title_key` headline, its `timestamp_key` (as datetime, mono meta on
// the right), and an optional `description_key` body line.
export function TimelineWidget(props: {
  spec: TimelineWidgetSpec;
  rows: readonly PageRow[];
}): JSX.Element {
  return (
    <Show when={props.rows.length > 0} fallback={<p class="widget__empty">{t('widgets.empty')}</p>}>
      <ol class="timeline widget-timeline">
        <For each={props.rows}>
          {(row) => (
            <li class="timeline__item">
              <span class="timeline__dot" aria-hidden="true" />
              <div class="timeline__summary">
                <span class="timeline__title">{formatCell(row[props.spec.title_key])}</span>
                <time class="timeline__meta">
                  {formatCell(row[props.spec.timestamp_key], 'datetime')}
                </time>
              </div>
              <Show when={props.spec.description_key}>
                {(key) => <p class="widget-timeline__desc">{formatCell(row[key()])}</p>}
              </Show>
            </li>
          )}
        </For>
      </ol>
    </Show>
  );
}
